module.exports = __webpack_public_path__ + "8bbcbdf8b0b689e040596744237904f7.MP3";